<template>
  <div class="service-visit-page">
    <KTCard ref="preview" v-bind:title="'View'">
      <template v-slot:title>
        <h3 class="card-label">
          <router-link :to="{ name: 'list-service-visit-comments' }">
            {{ $t("SERVICE_VISIT_COMMENTS.TITLE") }}
          </router-link>
          <i class="mr-2"></i>
          <small class="">{{ $t("LABELS.VIEW") }}</small>
        </h3>
      </template>
      <template v-slot:toolbar>
        <div class="d-flex flex-wrap">
          <BackButton></BackButton>
        </div>
      </template>
      <template v-slot:body>
        <v-skeleton-loader
          v-if="firstLoader"
          :loading="firstLoader"
          type="article"
        ></v-skeleton-loader>

        <v-card v-else flat>
          <p>
            <strong>{{ $t("SERVICE_VISIT_COMMENTS.SERVICE_VISIT") }}:</strong>
            {{ serviceVisitName(comment.serviceVisit) }}
          </p>
          <p>
            <strong>{{ $t("SERVICE_VISIT_COMMENTS.AUTHOR") }}:</strong>
            {{ comment.authorName || "-" }}
          </p>
          <p>
            <strong>{{ $t("FORM_LABELS.STATUS") }}:</strong>
            {{ comment.status ? comment.status.name : "-" }}
          </p>
          <p>
            <strong>{{ $t("SERVICE_VISIT_COMMENTS.CREATED_AT") }}:</strong>
            {{ comment.createdAt | formatDateTime }}
          </p>
          <div>
            <strong>{{ $t("SERVICE_VISIT_COMMENTS.BODY") }}:</strong>
            <div class="white-space-pre-wrap mt-2">{{ comment.body || "-" }}</div>
          </div>
        </v-card>
      </template>
      <template v-slot:toolbarfoot>
        <div class="d-flex flex-wrap">
          <BackButton></BackButton>
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { FETCH_SERVICE_VISIT_COMMENT } from "@/modules/service-visit-comments/store/service-visit-comments.module";
import KTCard from "@/view/content/Card.vue";

export default {
  name: "ServiceVisitCommentsShow",
  components: {
    KTCard
  },
  data() {
    return {
      firstLoader: true,
      comment: {}
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.$i18n.t("SERVICE_VISIT_COMMENTS.TITLE"),
        route: { name: "list-service-visit-comments" }
      },
      { title: this.$i18n.t("LABELS.VIEW") }
    ]);
    this.getServiceVisitComment();
  },
  methods: {
    getServiceVisitComment() {
      this.$store
        .dispatch(FETCH_SERVICE_VISIT_COMMENT, this.$route.params.id)
        .then(data => {
          this.comment = data.data;
          this.firstLoader = false;
        })
        .catch(response => {
          if (response.status === 404) {
            this.$notify({
              group: "notify",
              type: "error",
              text: "Nout Found"
            });
            this.$router.push({ name: "list-service-visit-comments" });
          }
        });
    },
    serviceVisitName(serviceVisit) {
      if (!serviceVisit) return "-";

      const machine = serviceVisit.machine;
      const machineName = machine
        ? machine.serviceDisplayName || machine.name || "-"
        : "-";

      return `${machineName} — ${serviceVisit.dateFrom || "-"}`;
    }
  }
};
</script>
